import * as React from 'react';
import { colors } from '../../../designSystem/colors/color';




export function ColorOverview(): JSX.Element
{
    return (
        <>
            <h1>Colors</h1>
            <NestedColorObject2 object={colors} prefix="" />
        </>
    );
}

const levelMultiplier = 20;

type NestedColorObjectProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    object:any,
    level:number
}
function NestedColorObject(props:NestedColorObjectProps):JSX.Element
{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const values:({name:string, hexColor:string, type:'hex'} | {name:string, object:any, type:'obj'}) [] = [];

    Object.keys(props.object).map(key => {
        if(key && typeof props.object[key] === 'string')
        {
            values.push({name:key, hexColor:props.object[key], type:'hex'});
        }
        else if(key && typeof props.object[key] === 'object')
        {
            values.push({name:key, object:props.object[key], type:'obj'});
        }
    });

    return (
        <div style={{border:`${props.level}px solid #ccc`, paddingLeft:props.level*levelMultiplier}}>
            {values.map(v => 
                v.type === 'hex' 
                    ? 
                        <div key={v.name} style={{display:'flex', minWidth:'100px'}}>
                            <div>{v.name}</div>
                            <div style={{backgroundColor:v.hexColor}}>{v.hexColor}</div>
                        </div>
                    :
                        <div key={v.name}>
                            <h3>{v.name}</h3>
                            <NestedColorObject object={v.object} level={props.level+1} />
                        </div>
            )}
        </div>
    );
}

type NestedColorObject2Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    object:any,
    prefix:string,
}
function NestedColorObject2(props:NestedColorObject2Props):JSX.Element
{
    return (
        <>
            {Object.keys(props.object).map(key =>
            {
                const name = (props.prefix ? (props.prefix + '.') : '') + key;
                return (
                    <>
                        {key && typeof props.object[key] === 'string' &&
                            <div key={key} style={{display:'flex', minWidth:'100px'}}>
                                <div>{name}</div>
                                <div style={{backgroundColor:props.object[key]}}>{props.object[key]}</div>
                            </div>
                        }
                        {key && typeof props.object[key] === 'object' &&
                            <NestedColorObject2 key={key} object={props.object[key]} prefix={name} />
                        }
                    </>
                );
            })}
        </>
    );
}